import React from 'react';
import { Box } from '@mui/material';

const Separator = ({theme='light-theme'}) => (
    <Box
        sx={{
            width: '100%',
            height: '1px',
            minHeight: '1px', // Forces the browser to respect the 1px height
            flexShrink: 0,    // Stops Flexbox from squishing it to 0px
            background:theme==='dark-theme'? 'linear-gradient(90deg, rgba(91,140,203, 0) 0%, rgba(91,140,203, 1) 46%, rgba(91,140,203, 0) 100%)':
             'linear-gradient(90deg, rgba(55, 65, 81, 0) 0%, rgba(55, 65, 81, 1) 46%, rgba(55, 65, 81, 0) 100%)',
        }}
    />
);

export default Separator;